import { createStyles, rem } from '@affstore-ds/uikit'

export const useInputLoaderStyles = createStyles(() => ({
  root: {
    width: rem(20),
    height: rem(20),
  },
}))
